const { primitives } = require('../../primitives')

const backgroundVariables = {
  high: primitives['neutral'][0],
  'high-hover': primitives['neutral'][100],
  medium: primitives['neutral'][100],
  'medium-hover': primitives['neutral'][200],
  default: primitives['neutral'][200],
  'default-hover': primitives['neutral'][300],
  low: primitives['neutral'][300],
  'low-hover': primitives['neutral'][400],
  contrast: primitives['forest'][900],
  disabled: primitives['neutral'][200],
}

module.exports = { backgroundVariables }
